import Cookies from "universal-cookie";
import moment from "moment-jalaali";

export const checkVisit = (uId, socket) => {
	const cookie = new Cookies();
	if(cookie.get('appview'))
	return;
	let expireDate = moment(new Date()).add(1, 'day').startOf('day');
	expireDate = new Date(expireDate)
	cookie.set('appview', {isLoggedIn: 'true', UID: uId}, {path:'/', expires:expireDate})

}
export const checkVisitProducts = (msg) => {
	let productInfo = JSON.parse(msg);
	const cookie = new Cookies();
	let products = [];
	if(cookie.get('pview')){
		let oldCookie = cookie.get('pview');
		products = JSON.parse(oldCookie.products);
		products.push({type: productInfo.type, pID: productInfo.pID})
	}
	else{
		products.push({type: productInfo.type, pID: productInfo.pID})
	}

	cookie.set('pview', {products: JSON.stringify(products)}, {path:'/'});

}
